import { useEffect, useMemo, useRef, useState } from "react";
import style from "../styles/formstep.module.scss";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { selectUser } from "../state/features/userSlice";
import {
  selectStep,
  selectActiveStep,
  selectCurrentIndex,
} from "../state/features/stepSlice";
import execute from "../requests/frappe";
import { CSteps } from "../components/steps/steps";
import {
  DocumentText,
  Eye,
  Message,
  TicketStar,
  UserSquare,
  Location,
} from "iconsax-react";
import {
  CheckOutlined,
  CloudDownloadOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  FilePdfFilled,
} from "@ant-design/icons";
import { Form, FormInstance, Tabs, Steps, Spin, Empty, Tooltip } from "antd";
import { searchInsert } from "../utils/insertion_point";
import clsx from "clsx";
import AbstractForm from "../components/forms/abstract";
import moment from "moment";
import { openNotification } from "../utils/notification";

function hydrate_initial_repeats(placeholder = {}, amount: any) {
  const returnable = [];
  for (let i = 0; i < amount; i++) {
    returnable.push(placeholder);
  }
  return returnable;
}

function StepsIndicator({ data, change, subChange, titleVisibleChange }: any) {
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  useEffect(() => {
    titleVisibleChange?.(isTitleVisible);
  }, [isTitleVisible]);
  return (
    <div
      className={clsx(style.step_wrapper, isTitleVisible && style.fill_width)}
    >
      {data?.map((step: any, i: number) => (
        <>
          <div
            key={step}
            onClick={() => change(i)}
            className={clsx(
              style.step_item,
              isTitleVisible && style.name_visible
            )}
          >
            <div
              className={clsx(
                style.step_indicator_container,
                step.curr > i &&
                  (step.status === "error"
                    ? style.step_indicator_container_error_active
                    : style.step_indicator_container_active),
                step.subTasks.length > 0 &&
                  style.step_indicator_container_hidden
              )}
            >
              <div
                className={clsx(
                  style.step_indicator,
                  style.step_indicator_big,
                  step.selected && style.step_indicator_big_selected,
                  step.status === "error" &&
                    (step.selected
                      ? style.step_indicator_big_selected_error
                      : style.step_indicator_big_error)
                )}
              >
                {step.status === "finish" ? <CheckOutlined /> : i + 1}
              </div>
            </div>
            <span
              className={clsx(
                style.title_container,
                style.title_container_primary,
                step.selected && style.title_container_primary_active
              )}
            >
              {step.title}
            </span>
          </div>
          {step.subTasks.map((tsk: any, j: number) => (
            <div
              key={tsk}
              onClick={() => {
                change(i);
                document.getElementById(tsk.uid)?.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }}
              className={clsx(
                style.step_item,
                isTitleVisible && style.name_visible
              )}
            >
              <div
                className={clsx(
                  style.step_indicator_container,
                  style.step_indicator_container_inner,
                  (step.curr > i || step.currSub > j) &&
                    (tsk.status === "error"
                      ? style.step_indicator_container_error_active
                      : style.step_indicator_container_active)
                )}
              >
                <div
                  className={clsx(
                    style.step_indicator,
                    style.step_indicator_small,
                    tsk.selected && style.step_indicator_small_selected,
                    tsk.status === "error" &&
                      (step.selected
                        ? style.step_indicator_small_selected_error
                        : style.step_indicator_small_error)
                  )}
                />
              </div>
              <span
                className={clsx(
                  style.title_container,
                  style.title_container_secondary,
                  tsk.selected && style.title_container_secondary_active,
                  tsk.status === "error" &&
                    style.title_container_secondary_error
                )}
              >
                {tsk.title}
              </span>
            </div>
          ))}
        </>
      ))}
      <button
        className={style.show_title}
        onClick={() => {
          setIsTitleVisible(!isTitleVisible);
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isTitleVisible ? <DoubleLeftOutlined /> : <DoubleRightOutlined />}
        </div>
      </button>
    </div>
  );
}

function displayArrays(array: any) {
  if (array && array.length > 0) {
    // Check the number of items in the array
    if (array.length === 1) {
      // If there's only one item, display it itself
      return array[0];
    } else {
      // If there are multiple items, display them separated by commas
      return array.join(", ");
    }
  } else {
    // If the array is empty or undefined, display nothing
    return null;
  }
}

export const ApplicationDetail = () => {
  const user = useSelector(selectUser);
  const isLoggedIn = !!user;
  const selectedStep = useSelector(selectStep);
  const activeStep = useSelector(selectActiveStep);
  const currentIndex = useSelector(selectCurrentIndex);
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState<any>("");
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  const [validation, setValidation] = useState<any>({});
  const [customTable, setCustomTable] = useState<any>({});
  const [currField, setCurrField] = useState(0);
  const [percentageComplete, setPercentageComplete] = useState<any>(0);

  const [currTab, setCurrent] = useState(data?.steps?.current || 0);

  const formRef = useRef<FormInstance<any>>(null);
  const { Step } = Steps;

  const Fetch_Data = async () => {
    const temp_data = await execute("GET_APPLICATION_DATA", {
      app: params?.name,
      user: user?.email,
    });
    setData(temp_data);
  };

  useEffect(() => {
    if (data === "" && user) {
      Fetch_Data();
    }
  }, [data, user]);
  
  useEffect(() => {
    let timer_waiter: number | any;
    if (typeof window !== "undefined") {
      (window as any).rf = formRef.current;
    }
    if (typeof window !== "undefined") {
      let new_valid = 0,
        new_total = 0;
      if (customTable) {
        const values = (formRef?.current as any)?.getFieldsValue() || {};
        form
          ?.reduce((prev: any, curr: any, i: number, arr: any) => {
            return [...prev, ...curr.fields];
          }, [])
          ?.map(
            (fld: any) => {
              if (
                ["title", "colend", "colstart"].indexOf(
                  fld.type || fld.data.type
                ) !== -1
              ) {
                return;
              }

              const countable = customTable[fld.name]
                ? 1
                : fld.conditions.length > 0
                ? 1
                : (typeof values[fld.name] != "undefined" &&
                    values[fld.name] !== null) === true
                ? 1
                : 0;

              new_valid += countable;
              new_total += 1;
            },
            [0, 0]
          );

        setPercentageComplete(((new_valid / new_total) * 100).toFixed(1));
      }

      (window as any).validateAllForm = async (
        _value: any,
        _fld_vals = null,
        $error_list = null,
        step_id = null
      ) => {
        clearTimeout(timer_waiter);
        const timed_await = async () => {
          const values =
            _fld_vals || (formRef?.current as any)?.getFieldsValue() || {};

          if (!_fld_vals) {
            setCurrField(_value);
            let valid = 0,
              total = 0;

            form
              .reduce((prev: any, curr: any, i: number, arr: any) => {
                return [...prev, ...curr.fields];
              }, [])
              .map(
                (fld: any) => {
                  if (
                    ["title", "colend", "colstart"].indexOf(
                      fld.type || fld.data.type
                    ) !== -1
                  ) {
                    return;
                  }
                  const countable = customTable[fld.name]
                    ? 1
                    : fld.conditions.length > 0
                    ? 1
                    : (typeof values[fld.name] != "undefined" &&
                        values[fld.name] !== null) === true
                    ? 1
                    : 0;
                  valid += countable;
                  total += 1;
                },
                [0, 0]
              );
            setPercentageComplete(((valid / total) * 100).toFixed(1));
          }

          const error_list =
            $error_list || (formRef?.current as any)?.getFieldError(_value);
          if ((error_list?.length || 0) === 0) {
            const validity = validation || {};
            if (!_fld_vals) {
              validity[currTab] = { ...(validity[currTab] || {}) };
              if (validity[currTab]) {
                validity[currTab][_value] = true;

                setValidation({ ...{ ...validity } });
              }
            } else {
              return true;
            }
          } else {
            const validity = validation || {};
            if (!_fld_vals) {
              validity[currTab] = { ...(validity[currTab] || {}) };
              if (validity[currTab]) {
                validity[currTab][_value] = error_list
                  .map((err: any) => `- ${err}\n`)
                  .join("");
                setValidation({ ...{ ...validity } });
              }
            } else {
              return error_list.map((err: any) => `- ${err}\n`).join("");
            }
          }
        };
        if (_fld_vals) {
          const $validation = await timed_await();

          timer_waiter = setTimeout(() => {
            let valid = 0,
              total = 0;
            const values =
              _fld_vals || (formRef?.current as any)?.getFieldsValue() || {};
            form
              .reduce((prev: any, curr: any, i: number, arr: any) => {
                return [...prev, ...curr.fields];
              }, [])
              .map(
                (fld: any) => {
                  if (
                    ["title", "colend", "colstart"].indexOf(
                      fld.type || fld.data.type
                    ) !== -1
                  ) {
                    return;
                  }
                  if (customTable[fld.name]) {
                    // console.log("second");
                  }
                  const countable = customTable[fld.name]
                    ? 1
                    : fld.conditions.length > 0 || !(fld.required || false)
                    ? 1
                    : (typeof values[fld.name] != "undefined" &&
                        values[fld.name] !== null) === true
                    ? 1
                    : 0;
                  valid += countable;
                  total += 1;
                },
                [0, 0]
              );
            setPercentageComplete(((valid / total) * 100).toFixed(1));
          }, 600);
          return $validation;
        } else {
          timer_waiter = setTimeout(timed_await, 400);
        }
      };
      (window as any).validateAllFields = async () => {
        try {
          await (window as any).rf.validateFields();
        } catch (e: any) {
          const $val_map = form.reduce((prev: any, curr: any, i: number) => {
            return [...prev, curr.fields.map((fld: any) => fld.uid)];
          }, []);
          const $validations = await Promise.all(
            e.errorFields.map(async ({ name: _fl_name, errors }: any) => {
              return {
                name: _fl_name.join("."),
                value: await (window as any).validateAllForm(
                  _fl_name.join("."),
                  e.values,
                  errors
                ),
              };
            })
          );

          const $_valid = $validations.reduce((prev, curr, i) => {
            const $f_tab = $val_map
              .map(($curr: any, $i: any) => ({
                fld: $curr,
                id: $i,
              }))
              .filter(($map: any) => {
                const $v_fld_name = curr.name?.split?.(".")?.[0] || curr.name;
                return $map.fld.indexOf($v_fld_name) !== -1;
              })[0]?.id;
            return {
              ...prev,
              [$f_tab]: {
                ...(prev?.[$f_tab] || {}),
                [curr.name?.split?.(".")?.[0] || curr.name]: curr.value,
              },
            };
          }, {});
          setValidation($_valid);
        }
      };
      document.cookie = `${encodeURIComponent(
        data?.application_data?.title
      )}-tab=${currTab}`;
    }
  }, [currTab, customTable]);

  const prev_data = data?.application_data?.raw_data && {
    ...JSON.parse(data?.application_data?.raw_data),
    ...data?.form
      ?.reduce((prev: any, curr: any) => [...prev, ...curr.fields], [])
      ?.filter(
        (field: any) =>
          field?.data?.type === "group" &&
          !(
            JSON.parse(data?.application_data?.raw_data)?.[field.uid]?.length >
            0
          )
      )
      ?.reduce(
        (prev: any, curr: any) => ({
          ...prev,
          [curr.uid]: hydrate_initial_repeats(
            {},
            curr.data?.minimum_repeats || 0
          ),
        }),
        {}
      ),
  };

  const form = useMemo(() => {
    /**
     * @type {[]}
     */
    const $form = data?.application_data?.form?.form;
    for (let i = 0; i < $form?.length; i++) {
      $form[i].titles = $form[i]?.fields.reduce(
        (prev: any, fld: any, i: number) => {
          const out = prev;
          const type = fld.type || fld.data?.type;
          if (type === "title") {
            out.push(i);
          }
          return out;
        },
        []
      );
    }

    return $form;
  }, [data?.application_data?.form]);

  const tabs = [
    {
      label: (
        <span className=" pl-4 flex items-center">
          <Eye className="mr-2" variant="Bold" />
          Filled Forms
        </span>
      ),
      key: "1",
      children: (
        <div className="md:pl-4 grid grid-cols-5">
          <div className=" col-span-5 md:col-span-1 hidden md:grid">
            <StepsIndicator
              titleVisibleChange={(is_vis: boolean) => {
                setIsTitleVisible(is_vis);
              }}
              data={form?.map((step: any, i: number) => ({
                title: step.title,
                status: form[i]?.fields?.some((fld: any) => {
                  if (
                    ["title", "colend", "colstart"].indexOf(
                      fld.type || fld.data.type
                    ) !== -1
                  ) {
                    return false;
                  }
                  return typeof validation?.[i]?.[fld.name] === "string";
                })
                  ? "error"
                  : form[i]?.fields?.every((fld: any) => {
                      if (
                        ["title", "colend", "colstart"].indexOf(
                          fld.type || fld.data.type
                        ) !== -1
                      ) {
                        return true;
                      }
                      return validation?.[i]?.[fld.name] === true;
                    })
                  ? "finish"
                  : "wait",
                selected: currTab === i,
                curr: currTab,
                currSub:
                  searchInsert(
                    form[i].titles,
                    form[i]?.fields.findIndex(
                      (fld: any) => fld.uid === currField
                    )
                  ) - 1,
                subTasks: form[i]?.fields
                  ?.filter((fld: any) => fld.type === "title")
                  .map((fld: any, k: number) => ({
                    uid: fld.uid,
                    title: fld.label,
                    selected:
                      currTab === i &&
                      k ===
                        searchInsert(
                          form[i].titles,
                          form[i]?.fields.findIndex(
                            (fld: any) => fld.uid === currField
                          )
                        ) -
                          1,
                    status: form[i]?.fields
                      ?.slice(form[i].titles[k], form[i].titles?.[k + 1])
                      ?.some((fld: any) => {
                        if (
                          ["title", "colend", "colstart"].indexOf(
                            fld.type || fld.data.type
                          ) !== -1
                        ) {
                          return false;
                        }
                        return typeof validation?.[i]?.[fld.name] === "string";
                      })
                      ? "error"
                      : form[i]?.fields
                          ?.slice(form[i].titles[k], form[i].titles?.[k + 1])
                          ?.every((fld: any) => {
                            if (
                              ["title", "colend", "colstart"].indexOf(
                                fld.type || fld.data.type
                              ) !== -1
                            ) {
                              return true;
                            }
                            return validation?.[i]?.[fld.name] === true;
                          })
                      ? "finish"
                      : "wait",
                  })),
              }))}
              change={(cc: number) => setCurrent(cc)}
              current={currTab}
            />
          </div>
          <div className="bg-white col-span-5 md:col-span-4 pt-4 pl-7 mb-20">
            <Form
              className="pt-4 pr-7"
              hideRequiredMark={false}
              initialValues={prev_data}
              ref={formRef}
              labelAlign={"left"}
              validateTrigger={"onChange"}
              layout={"vertical"}
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                marginBottom: "20px",
              }}
            >
              {currTab === 0}
              {form?.map((step: any, i: number) => (
                <AbstractForm
                  key={i}
                  disabled={true}
                  secondary_form={false}
                  prev_data={prev_data}
                  form={formRef}
                  visible={i === currTab}
                  fields={step.fields}
                />
              ))}
              <div style={{ flex: 1, width: 0 }} />
              <div className="">
                {currTab < form?.length - 1 && (
                  <div
                    onClick={() => {
                      setCurrent(currTab + 1);
                    }}
                    className="bg-[#096DD9] w-[20%] flex justify-center py-2 rounded-md text-white cursor-pointer"
                  >
                    Next
                  </div>
                )}

                {currTab > 0 && (
                  <div
                    onClick={() => {
                      setCurrent(currTab - 1);
                    }}
                    className="bg-white w-[20%] flex justify-center py-2 rounded-md text-black cursor-pointer border-[1px] hover:text-blue hover:border-blue"
                  >
                    Back
                  </div>
                )}
              </div>
            </Form>

            <div className="" />
          </div>
        </div>
      ),
    },
    {
      label: (
        <span className=" flex items-center">
          <DocumentText className="mr-2" variant="Bold" />
          Documents Attached
        </span>
      ),
      key: "2",
      children: (
        <div className=" grid bg-white px-3 py-5">
          {data?.attachment?.length == 0 && (
            <div className=" mt-[2%] w-full flex items-center justify-center">
              <Empty />
            </div>
          )}
          {data?.attachment?.map((file: any, z: number) => (
            <p
              key={"file" + z}
              className=" flex w-full justify-between items-center hover:bg-light_blue "
              onClick={() => {
                window.open(file.url, "_blank");
              }}
            >
              <a
                className="ml-[10px] text-black no-underline my-1"
                key={file.attachment_name + z}
                // href={`${file.url}`}
                // target="_blank"
              >
                <FilePdfFilled
                  style={{ marginRight: "10px", fontSize: "17px" }}
                />
                {file.attachment_name}
              </a>

              <CloudDownloadOutlined className="mr-10" />
            </p>
          ))}
        </div>
      ),
    },
  ];

  if (!isLoggedIn || !data) {
    return (
      <div className=" w-full flex items-center justify-center mt-[20%]">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      {isLoggedIn && data && (
        <div className="w-full mt-[1%] bg-general_bg grid grid-cols-3 xl:grid-cols-4">
          <div className=" col-span-3 mr-[1%]">
            <div className=" flex justify-between items-center">
              <div className=" max-w-[80%] truncate">
                <span
                  className="text-[#00000073] hover:text-blue cursor-pointer"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  Home / Application assigned
                </span>{" "}
                /{" "}
                <Tooltip placement="bottom" title={params.name}>
                  {params.name}
                </Tooltip>
              </div>
              {data.status && (
                <button
                  className={`px-[4%] mx-2 py-2 rounded-md text-white bg-blue_btn`}
                  onClick={async () => {
                    navigate(
                      `/certificate/${data?.application_data?.uac}/${data?.application_data?.user}`
                    );
                  }}
                >
                  Certificate
                </button>
              )}
              <button
                className={`px-[4%] py-2 rounded-md text-white ${
                  data?.application_data.current_step_name
                    ? "bg-blue"
                    : " cursor-not-allowed bg-[#B0C4DE]"
                }`}
                disabled={
                  data.application_data.current_step_name ? false : true
                }
                onClick={async () => {
                  if (data.payment) {
                    openNotification(
                      "Error",
                      "Payment hasn't been settled",
                      "error"
                    );
                    return;
                  }

                  if (
                    data.permitted_user === user.email &&
                    (!activeStep?.includes(selectedStep + 1) ||
                      (activeStep?.includes(selectedStep + 1) &&
                        selectedStep < currentIndex))
                  ) {
                    navigate(
                      `/evaluate/${data.application_data?.title}/${data.application_data?.user}/${data.steps?.list[currentIndex].step_name}/${data.steps?.list[currentIndex].step_id}`,
                      { replace: true }
                    );
                  }
                  const temp_resp = await execute("CHECK_STEP_USER", {
                    step_no: selectedStep + 1,
                    application: data.application_data?.title,
                  });
                  if (temp_resp[0] === user.email) {
                    navigate(
                      `/evaluate/${data.application_data?.title}/${data.application_data?.user}/${data.steps?.list[selectedStep].step_name}/${data.steps?.list[selectedStep].step_id}`,
                      { replace: true }
                    );
                  } else {
                    openNotification(
                      "Error",
                      "This Step is Not Assigned to you",
                      "error"
                    );
                  }
                }}
              >
                Evaluate
              </button>
            </div>
            <div className="bg-white mt-[1%] ">
              <div className="p-4 grid grid-cols-5 gap-7">
                <p className=" grid grid-cols-5 col-span-4 font-[700]">
                  Application Name:
                  <span className=" col-span-4">{params.name}</span>
                </p>
                <p className=" col-span-1">
                  {" "}
                  UAC: {data?.application_data?.uac}
                </p>
              </div>
              <div className=" xsm:p-4 border-y-[1px]">
                <CSteps steps={data?.steps} />
              </div>

              <div className="p-4 flex items-center">
                Note:{" "}
                <span
                  className=" ml-2"
                  dangerouslySetInnerHTML={{
                    __html: data?.steps?.list[selectedStep]?.html_output_text,
                  }}
                ></span>
              </div>
            </div>
            <div className=" bg-white">
              <Tabs
                className=" bg-white mb-20"
                defaultActiveKey="1"
                items={tabs}
              />
            </div>
          </div>
          <div className=" hidden xl:block">
            <div className="bg-white w-[87%] py-4 px-5 mb-5">
              <p className=" flex my-3 items-center">
                <UserSquare color="#0F47AF" size={20} className=" mr-2" />{" "}
                <span className=" font-[600] mr-2">Assigned for:</span>
                {data?.full_name}
              </p>
              <p className="flex my-3 items-center">
                <TicketStar color="#F31919" size={20} className=" mr-2" />
                <span className=" font-[600] mr-2"> UAC:</span>
                {data?.application_data?.uac}
              </p>
              <div className=" my-3 flex flex-wrap">
                <span className="font-[600] mr-2 flex items-center">
                  <Location color="#358B00" size={20} className=" mr-2" /> City:
                </span>
                {displayArrays(data?.application_data?.region)}
                <span className=" ml-2 pl-4 lg:border-l-[1px] border-[#C5C5C5] lg:border-solid font-[600] mr-2 flex items-center">
                  Sub city:
                </span>
                {displayArrays(data?.application_data?.sub_city)}
              </div>
              <div className=" my-3 flex flex-wrap">
                <span className="font-[600] mr-2 flex items-center ">
                  <Location color="#9747FF" size={20} className=" mr-2" />{" "}
                  Woreda :
                </span>
                {displayArrays(data?.application_data?.woreda)}
              </div>

              {/* TODO */}
              <div className=" flex items-center ml-1">
                Evaluation Type:
                <span className=" bg-[#1890FF] text-white px-2 py-1 ml-3 rounded-md">
                  manual
                </span>
              </div>
            </div>
            <h2 className="ml-10 mb-8 font-semibold">Activity Log</h2>
            <Steps direction="vertical" current={100000}>
              {data?.personal_activity?.map((log: any) => {
                return (
                  <Step
                    key={log.name}
                    icon={<Message size={14} />}
                    description={
                      <div className=" bg-white mr-14 rounded-md">
                        {Object.keys(JSON.parse(log.data)).map(
                          (alter_type: any) => {
                            if (JSON.parse(log.data)[alter_type]?.length > 0) {
                              return (
                                <div
                                  className=" text-black"
                                  key={"step" + alter_type}
                                >
                                  <div className=" flex px-4 py-2">
                                    <span className=" font-semibold">You</span>
                                    <p className="ml-4 text-gray-500">
                                      {moment(log.creation).fromNow()}
                                    </p>
                                  </div>
                                  <p className=" px-4 h-fit w-fit pb-3 font-semibold flex flex-wrap items-center">
                                    <span className=" pr-2 font-normal">
                                      {alter_type}{" "}
                                    </span>
                                    {JSON.parse(log.data)[alter_type][0][0]}
                                    <span className=" px-2 font-normal">
                                      from
                                    </span>{" "}
                                    {JSON.parse(log.data)[alter_type][0][1]}
                                    <span className="px-2 font-normal">
                                      {" "}
                                      to
                                    </span>{" "}
                                    {JSON.parse(log.data)[alter_type][0][2]}
                                  </p>
                                </div>
                              );
                            }
                          }
                        )}
                      </div>
                    }
                  />
                );
              })}
            </Steps>
          </div>
        </div>
      )}
    </>
  );
};
